import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    document.addEventListener("click", this.handleOutsideClick.bind(this));
    window.addEventListener("close-popovers", this.hide.bind(this))
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick.bind(this));
    window.addEventListener("close-popovers", this.hide.bind(this))
  }

  toggle() {
    this.menuTarget.classList.toggle("hidden")
  }

  hide() {
    this.menuTarget.classList.add("hidden")
  }

  handleOutsideClick(event) {
    if (
      !this.element.contains(event.target) &&
      !this.menuTarget.contains(event.target)
    ) {
      this.menuTarget.classList.add("hidden");
    }
  }
}
